import { useMemo } from 'react';
import { OwnershipOption, UseOwnershipOptionsProps } from './useOwnershipOptions.props';

export const useOwnershipOptions = ({
  companyInfo,
  fundList,
  cashFlows = [],
}: UseOwnershipOptionsProps): OwnershipOption[] =>
  useMemo(() => {
    const options: OwnershipOption[] = [];

    // Extract fund IDs that have ownership in this company from virtual cash flow rows
    // Virtual rows come from FundOwnershipDetails, representing actual fund holdings
    const fundsWithOwnership = new Set<number>();
    cashFlows.forEach(item => {
      if (item.is_virtual && item.owner_fund) {
        fundsWithOwnership.add(item.owner_fund);
      }
    });

    // Only add funds that have ownership in this company (appear in virtual rows)
    if (Array.isArray(fundList)) {
      const fundOptions = fundList
        .filter(fund => fund.id !== undefined && fundsWithOwnership.has(fund.id))
        .map(fund => ({
          id: `fund-${fund.id}`,
          value: `fund-${fund.id}`,
          label: fund.name ?? '',
          type: 'fund' as const,
        }));
      options.push(...fundOptions);
    }

    // Add child companies from companyInfo
    if (companyInfo?.child_companies) {
      const childCompanyOptions = companyInfo.child_companies.map((child: any) => ({
        id: `company-${child.company_id}`,
        value: `company-${child.company_id}`,
        label: child.company_name,
        type: 'company' as const,
      }));
      options.push(...childCompanyOptions);
    }

    return options;
  }, [companyInfo, fundList, cashFlows]);
